module.exports = __webpack_public_path__ + "files/65992055612a04bef2bc4c312739e7c6.png";